import { gql } from '@apollo/client';

export default gql`
  query allowedFreeTrial($partnerLocationId: ID) {
    allowedFreeTrial(partnerLocationId: $partnerLocationId)
  }
`;
